exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".reimbursement-summary{display:flex;flex-flow:row wrap}.reimbursement-summary .reimbursement-summary-aside{flex:0 0 auto;width:calc(99.99% * 1/4 - 15px)}.reimbursement-summary .reimbursement-summary-aside:nth-child(1n){margin-right:20px}.reimbursement-summary .reimbursement-summary-aside:last-child{margin-right:0}.reimbursement-summary .reimbursement-summary-aside:nth-child(4n){float:right;margin-right:0}.reimbursement-summary .reimbursement-summary-main{flex:0 0 auto;width:calc(99.99% * 3/4 - 5px)}.reimbursement-summary .reimbursement-summary-main:nth-child(1n){margin-right:20px}.reimbursement-summary .reimbursement-summary-main:last-child{margin-right:0}.reimbursement-summary .reimbursement-summary-main:nth-child(4n){float:right;margin-right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/reimbursement-summary/summary/components/index.scss
// module id = 5169
// module chunks = 0